import { FavoriteNonStandardMedicineModel } from "../../models/medic/favorite-non-standard-medicine.model";

export class MedicFavoriteNonStandardPrescriptionRequest {
    public listFavoriteNonStandardMedicine: FavoriteNonStandardMedicineModel[];
    public favoriteMedicineName: string;
    public idMedicFavoriteNonStandardPrescription: number;
    public shareWithMedicalTeam: boolean
}